module.exports = __webpack_public_path__ + "static/media/erkmenesen2.6bb9362c.jpg";